import React from 'react'
import { TeamCalendarProvider } from '../../../context/useTeamCalendarContext'
import CalendarPage from '../CalendarPage/CalendarPage'
import ContainerPadding from '../../../components/containerPadding/containerPadding'
import isSelectedOrgCompetitionOrFederation from '../../../utils/helpers/isSelectedOrgCompetitionOrFederation'

const CalendarPageProvider = () => {
  return (
    <TeamCalendarProvider teamsSource={isSelectedOrgCompetitionOrFederation() ? 'season' : 'organization'}>
      <ContainerPadding>
        <CalendarPage />
      </ContainerPadding>
    </TeamCalendarProvider>
  )
}

export default CalendarPageProvider
